import { createReducer, on } from '@ngrx/store';
import * as AdditionalServicesActions from './additional-services.actions';
import { AdditionalServiceLevelResponse } from 'src/app/pages/orders/interfaces/additionalService.interface';

export interface AdditionalServicesState {
  response: AdditionalServiceLevelResponse | null;
  request: AdditionalServicesActions.AdditionalServiceLevelRequest | null;
  // type any because error interface is not defined in the provided code
  // and it can be any type of error (string, object, etc.)
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: AdditionalServiceLevelResponse };
}

export const initialState: AdditionalServicesState = {
  response: null,
  request: null,
  error: null,
  loading: false,
  cache: {},
};

export const additionalServicesReducer = createReducer(
  initialState,
  on(AdditionalServicesActions.loadAdditionalServiceLevel, (state) => ({
    ...state,
    loading: true,
    error: null as any, // type any because error interface is not defined in the provided code
  })),
  on(AdditionalServicesActions.loadAdditionalServiceLevelSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null as any, // type any because error interface is not defined in the provided code
  })),
  on(AdditionalServicesActions.loadAdditionalServiceLevelFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AdditionalServicesActions.retryAdditionalServiceLevel, (state) => ({
    ...state,
    loading: true,
    error: null as any, // type any because error interface is not defined in the provided code
  })),
  on(AdditionalServicesActions.loadAdditionalServiceLevelRequest, (state, { request }) => ({
    ...state,
    request,
  })),
  // Store response by key and also set as current response
  on(AdditionalServicesActions.loadAdditionalServiceLevelSuccessByKey, (state, { key, response }) => ({
    ...state,
    response,
    loading: false,
    cache: { ...(state.cache || {}), [key]: response },
    error: null as any,
  })),
);
